/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_Copy_FailedInputs */

const en_two_fa_recovery_copy_failed = /** @type {(inputs: Two_Fa_Recovery_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy the codes. Download them or save them manually.`)
};

const nl_two_fa_recovery_copy_failed = /** @type {(inputs: Two_Fa_Recovery_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De codes konden niet worden gekopieerd. Download ze of sla ze handmatig op.`)
};

/**
* | output |
* | --- |
* | "Could not copy the codes. Download them or save them manually." |
*
* @param {Two_Fa_Recovery_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_copy_failed = /** @type {((inputs?: Two_Fa_Recovery_Copy_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_Copy_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_copy_failed(inputs)
	return en_two_fa_recovery_copy_failed(inputs)
});